import React from 'react';
import { Link } from 'react-router-dom'; // ✅ YES
import yogaLandscape from './assets/yoga_landscape.jpg';
import yoga6 from './assets/yoga_6.jpg';
import yoga7 from './assets/yoga_7.jpg';
import yoga8 from './assets/yoga_8.jpg';
import yoga_room from './assets/yoga_room.jpg';
import yoga_house from './assets/yoga_house.jpg';
import yoga_beach from './assets/yoga_beach.jpg';
import yoga_touch from './assets/yoga_touch.jpg';

const MaldivesRetreat = () => {
  return (
    <div style={{ scrollBehavior: 'smooth' }}>
      {/* Section 1: Hero Section */}
      <section
        style={{
          height: '100vh',
          backgroundImage: `url(${yogaLandscape})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'bottom',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            color: '#FAF3E0',
            textShadow: '0 2px 4px rgba(0,0,0,0.5)',
          }}
        >
          <h1 style={{ fontSize: '3rem', margin: 0 }}>Maldives Yoga Retreat 2026</h1>
          <p style={{ fontSize: '1.5rem', marginTop: '1rem' }}>February 20th – 27th</p>
        </div>
      </section>

      {/* Section 2: Aqua - Intro Text + 3 Images */}
      <section
        style={{
          backgroundColor: '#A0E7E5',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '3rem 2rem',
          fontFamily: '"Playfair Display", Georgia, serif',
          gap: '2rem',
        }}
      >
        <p
          style={{
            maxWidth: '800px',
            fontSize: '1.5rem',
            textAlign: 'center',
            color: '#004D4A',
            lineHeight: '1.7',
          }}
        >
          Come join me as we escape into paradise! Disconnecting from our daily lives and reconnecting back to ourselves.
          Surrounded by lush greenery, finding peace where turquoise waters meets white sandy shores.
          Simple living, connected to nature. The beauty of Thodhoo island awaits...
        </p>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: '1rem',
            width: '100%',
          }}
        >
          {[yoga6, yoga7, yoga8].map((img, idx) => (
            <div
              key={idx}
              style={{
                width: '30%',
                minWidth: '250px',
                height: '60vh',
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                src={img}
                alt={`Yoga ${idx + 6}`}
                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'cover' }}
              />
            </div>
          ))}
        </div>
      </section>

      {/* Section 3: Cream - Accommodation Text + 3 Images */}
      <section
        style={{
          backgroundColor: '#FFF4E0',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '3rem 2rem',
          fontFamily: '"Playfair Display", Georgia, serif',
          gap: '2rem',
        }}
      >
        <p
          style={{
            maxWidth: '800px',
            fontSize: '1.5rem',
            textAlign: 'center',
            color: '#5A3E1B',
            lineHeight: '1.7',
          }}
        >
          We will be staying at a boutique hotel, with daily housekeeping. Surrounded by nature and only minutes from the beach!
          Choice of single or shared accommodation.
        </p>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: '1rem',
            width: '100%',
          }}
        >
          {[yoga_room, yoga_house, yoga_beach].map((img, idx) => (
            <div
              key={idx}
              style={{
                width: '30%',
                minWidth: '250px',
                height: '60vh',
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                src={img}
                alt={`Retreat ${idx}`}
                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'cover' }}
              />
            </div>
          ))}
        </div>
      </section>

      {/* Section 4: Green - What's Included + 1 Image */}
      <section
        style={{
          backgroundColor: '#D0F4DE',
          padding: '3rem 2rem',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '2rem',
          fontFamily: '"Playfair Display", Georgia, serif',
        }}
      >
        <div style={{ flex: 1, minWidth: '300px', maxWidth: '500px' }}>
          <h3 style={{ color: '#003B2A', marginBottom: '1.5rem' }}>What's included:</h3>
          <ul style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#003B2A' }}>
            <li>8 days/7 nights full board at a boutique hotel with daily housekeeping</li>
            <li>3 delicious and locally grown vegetarian meals each day, with fresh seafood options</li>
            <li>Return transfer to and from Male' via ferry</li>
            <li>Daily yoga</li>
            <li>Cooking class, coconut workshop, island tour</li>
            <li>Snorkelling, sandbank trip, sunset cruise</li>
          </ul>
        </div>
        <div style={{ flex: 1, minWidth: '300px', maxWidth: '500px', textAlign: 'center' }}>
          <img
            src={yoga_touch}
            alt="Yoga Touch"
            style={{ maxWidth: '100%', height: 'auto', objectFit: 'cover' }}
          />
        </div>
      </section>

      {/* Section 5: Payment */}
      <section
        style={{
          height: '60vh',
          backgroundColor: '#E8FBFF',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '2rem',
        }}
      >
        <div
          style={{
            width: '90%',
            height: '100%',
            padding: '2rem',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: '1rem',
          }}
        >
          <h2>Maldives Yoga Retreat 2026</h2>
         
       {/*Uses React Router to navigate to the /register route without reloading the page and referenced in App.js*/}
        <Link to="/register">
        <button className="register-button">Register Now</button>
        </Link>

          <p>
            <strong>Payment Options:</strong><br />
            1. PayPal (Instant, credit cards accepted)<br />
            2. Bank Transfer (Australia only)<br />
            <span style={{ fontSize: '0.95rem', color: '#444' }}>
              <i>Bank details will be provided upon booking confirmation</i>
            </span>
          </p>
          <p>
            <strong>Deposit:</strong> Pay in full or place or deposit now with remainder due on arrival
          </p>
          <div style={{ display: 'inline-grid', justifyItems: 'center', gap: '0.5rem' }}>


          {/*Creates a nicely grouped “Pay Now” call-to-action area.The button opens PayPal in a new tab.
          Key behavior.window.open(url, '_blank') → opens PayPal checkout in a new tab/window.
          Important note (security best practice)*/}


            <button
              style={{
                textAlign: 'center',
                border: 'none',
                borderRadius: '1.5rem',
                minWidth: '11.625rem',
                padding: '0 2rem',
                height: '2.625rem',
                fontWeight: 'bold',
                backgroundColor: '#FFD140',
                color: '#000000',
                fontFamily: '"Helvetica Neue", Arial, sans-serif',
                fontSize: '1rem',
                lineHeight: '1.25rem',
                cursor: 'pointer',
              }}
              onClick={() => window.open('https://www.paypal.com/ncp/payment/NCZVQ2AZBW7LG', '_blank')}
            >
              Pay Now
            </button>
            <img src="https://www.paypalobjects.com/images/Debit_Credit.svg" alt="cards" />
            <div style={{ fontSize: '0.75rem' }}>
              Powered by{' '}
              <img
                src="https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-wordmark-color.svg"
                alt="paypal"
                style={{ height: '0.875rem', verticalAlign: 'middle' }}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MaldivesRetreat;
